import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import BASE_URL from "../BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddNewMessageLogModal from "./AddNewMessageLogModal";
import UpdateMessageLogModal from "./UpdateMessageLogModal";

function MessageLogs() {
  const history = useHistory();
  const [type, setType] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmailOrLink, setRecipientEmailOrLink] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [messageStatus, setMessageStatus] = useState("");
  const [message, setMessage] = useState("");
  const [description, setDescription] = useState("");
  const [messageLogs, setMessageLogs] = useState([]);
  const [selectedMessageLog, setSelectedMessageLog] = useState(null);
  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const [showModal2, setShowModal2] = useState(false); // State for modal visibility

  // Define fetchMessageLogs function before useEffect
  const fetchMessageLogs = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData ? userData.groupId : null;

    fetch(`${BASE_URL}/api/Expense/GetAllMesaageLog?UserID=${groupId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setMessageLogs(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const updateData = (newData) => {
    fetchMessageLogs();
  };
  useEffect(() => {
    fetchMessageLogs();
    // Redirect to login if not logged in (example check)
    if (!localStorage.getItem("userData")) {
      history.push("/login");
    }
  }, [history]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "type") setType(value);
    if (name === "recipientName") setRecipientName(value);
    if (name === "recipientEmailOrLink") setRecipientEmailOrLink(value);
    if (name === "messageStatus") setMessageStatus(value);
    if (name === "description") setDescription(value);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  // const handleEditClick = (messageLog) => {
  //   setSelectedMessageLog(messageLog);
  //   setShowModal2(true);
  // };
  const handleUpdate = (newData) => {
    fetchMessageLogs();
  };

  const handleResetForm = () => {
    setSelectedMessageLog(null);
  };

  const handleDeleteClick = (messageId) => {
    Swal.fire({
      title:
        "Are you sure you want to delete this message along with Thread Messages?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(
          `${BASE_URL}/api/Expense/DeleteMesaageLog?messageId=${messageId}`,
          {
            method: "POST",
          }
        )
          .then((response) => response.json())
          .then((data) => {
            Swal.fire("Deleted!", "Your message has been deleted.", "success");
            fetchMessageLogs(); // Fetch the updated message logs
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  const handleViewClick = (messageId) => {
    history.push({
      pathname: "/viewMessageLog",
      state: { messageId: messageId },
    });
  };

  const handleViewMessageThread = (
    messageId,
    recipientName,
    recipientEmailOrLink,
    messageStatus
  ) => {
    localStorage.setItem("messageId", messageId);
    localStorage.setItem("recipientName", recipientName);
    localStorage.setItem("recipientEmailOrLink", recipientEmailOrLink);
    localStorage.setItem("messageStatus", messageStatus);
    history.push({
      pathname: "/messageThreads",
      state: { messageId: messageId },
    });
  };
  const handleSubmitModal = () => {
    // Handle submit logic here
    // After successful submit or close
    setShowModal(false); // Close modal
    setSelectedMessageLog(null); // Reset selectedMessageLog state
    fetchMessageLogs(); // Fetch updated message logs
  };

  return (
    <>
      <style>{`
        .modal {
          display: flex;
          justify-content: center;
          align-items: center;
          position: fixed;
          z-index: 1000;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 999;
          backdrop-filter: blur(4px); /* Adjust the blur effect as needed */
        }

        .blur {
          filter: blur(4px); /* Adjust the blur effect as needed */
          pointer-events: none; /* Prevents clicking on blurred elements */
        }
          .w-full td {
            white-space: nowrap;
          }
             .thread-count,
          .follow-ups {
            width: 50px; /* Adjust the width as needed */
          }
      `}</style>
      <Navbar />
      <div className="cust-div">
        <BlockUiOverlay visible={false} />

        <div className="container mx-auto p-4">
          <div
            className={`flex items-center justify-between mb-4 ${
              showModal || showModal2 ? "blur" : ""
            }`}
          >
            <h1 className="text-2xl font-bold">Message Logs</h1>
            <button
              className=" px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-button"
              onClick={() => setShowModal(true)}
            >
              + Add New
            </button>
          </div>

          <AddNewMessageLogModal
            showModal={showModal}
            setShowModal={setShowModal}
            type={type}
            recipientName={recipientName}
            recipientEmailOrLink={recipientEmailOrLink}
            startDate={startDate}
            messageStatus={messageStatus}
            message={message}
            description={description}
            handleInputChange={handleInputChange}
            handleDateChange={handleDateChange}
            handleSubmit={handleSubmitModal} // Pass handleSubmitModal to handle modal close
            selectedMessageLog={selectedMessageLog}
            updateData={updateData}
          />
          <UpdateMessageLogModal
            showModal={showModal2}
            setShowModal={setShowModal2}
            selectedMessageLog={selectedMessageLog}
            updateData={handleUpdate}
            resetForm={handleResetForm}
          />

          <div
            className={`overflow-x-auto mt-6 ${
              showModal || showModal2 ? "blur" : ""
            }`}
          >
            <table className="w-full min-w-full">
              <tbody>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <td className="cell py-2 px-2 font-bold">Type</td>
                  <td className="cell py-2 px-4 font-bold">Recipient</td>
                  <td className="cell py-2 px-4 font-bold">
                    Recipient Email or Links
                  </td>
                  <td className="cell py-2 px-2 font-bold">Sent On</td>
                  <td className="cell py-2 px-4 font-bold">Status</td>
                  <td className="cell py-2 px-0 font-bold">Thread Count</td>
                  <td className="cell py-2 px-4 font-bold">Follow Up's</td>
                  <td className="cell py-2 px-4 font-bold">Description</td>
                  <td
                    className="cell py-2 px-2 font-bold"
                    style={{ float: "inline-end" }}
                  >
                    Actions
                  </td>
                </tr>
                {messageLogs.length > 0 ? (
                  messageLogs.map((log) => (
                    <tr
                      key={log.messageID}
                      className="hover:bg-gray-100 border-b"
                    >
                      <td className="cell py-1 px-2" title={log.type}>
                        {log.type}
                      </td>
                      <td
                        className="cell py-1 px-4"
                        title={
                          log.recipientName.length > 10 ? log.recipientName : ""
                        }
                      >
                        {log.recipientName.length > 10
                          ? `${log.recipientName.substring(0, 10)}...`
                          : log.recipientName}
                      </td>

                      <td
                        className="cell py-1 px-4"
                        title={
                          log.recipientEmailOrLink.length > 20
                            ? log.recipientEmailOrLink
                            : ""
                        }
                      >
                        {log.recipientEmailOrLink.length > 25
                          ? `${log.recipientEmailOrLink.substring(0, 25)}...`
                          : log.recipientEmailOrLink}
                      </td>

                      <td className="cell py-1 px-2">
                        {new Date(log.messageDate)
                          .toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true, // Keep 12-hour format
                          })
                          .replace(/am|pm/i, (match) => match.toUpperCase())}
                      </td>
                      <td className="cell py-1 px-4">
                        {log.messageStatus || "Primary Message"}
                      </td>
                      <td className="cell py-1 px-0 thread-count">
                        {log.threadMessageCount}
                      </td>
                      <td className="cell py-1 px-4 follow-ups">
                        {log.followUpCount}
                      </td>
                      <td
                        className="cell py-1 px-4"
                        title={
                          log.description.length > 20 ? log.description : ""
                        }
                      >
                        {log.description.length > 15
                          ? `${log.description.substring(0, 15)}...`
                          : log.description}
                      </td>

                      <td className="cell py-1 px-2 flex justify-end">
                        <img
                          title="Message Thread"
                          src={require("assets/img/MessageThreadIcon.png")}
                          alt="Message Thread"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() =>
                            handleViewMessageThread(
                              log.messageID,
                              log.recipientName,
                              log.recipientEmailOrLink,
                              log.messageStatus
                            )
                          }
                        />

                        <img
                        src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          title="Delete"
                       className="cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => handleDeleteClick(log.messageID)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      className="cell py-2 px-4"
                      colSpan="6"
                      style={{ textAlign: "center" }}
                    >
                      No message logs are available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MessageLogs;
